import React, { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

// Create context with default undefined to catch errors if not wrapped
export const DrawerContext = createContext(undefined);

export const DrawerProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = () => {
    setIsOpen(prev => !prev);
  };

  const value = useMemo(() => ({ isOpen, toggleDrawer }), [isOpen]);

  return (
    <DrawerContext.Provider value={value}>
      {children}
    </DrawerContext.Provider>
  );
};

DrawerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
